import React from 'react';
import { Form } from 'react-bootstrap';
import useSoftwareProductCart from 'software_products/hooks/useSoftwareProductCart';

const Cart = () => {
  const {
    product,
    licenseSpanPresentation,
    productName,
    selectedVariant,
    numberOfUsers,
    availableNumberOfUsers,
    isAddingToCart,
    licenseTypeText,
    onAddToCart,
    onQuantityChange,
  } = useSoftwareProductCart();

  return (
    <div id="cart" className="container-fluid add-to-cart">
      <div className="row cart-product-selection">
        <div className="col-12">
          <span>Your Selection:</span>
          <span className="product-name">{productName}</span>
          {!product.can_supply && (
            <span className="text-danger my-2 font-weight-bold">
              Out of Stock
            </span>
          )}
        </div>
      </div>

      <div className="row">
        <div className="col-12 mb-3">
          <div>
            License Type
            <br />
            <strong>{licenseTypeText}</strong>
          </div>
        </div>
        <div className="col-12 mb-3">
          <div>
            Subscription Period
            <br />
            <strong>{licenseSpanPresentation}</strong>
          </div>
        </div>
        <div className="col-12">
          <Form.Group>
            <Form.Label htmlFor="num_of_users">Number of Users</Form.Label>
            <Form.Control
              as="select"
              className="w-75"
              id="num_of_users"
              value={numberOfUsers}
              onChange={onQuantityChange}
            >
              {availableNumberOfUsers.map(({ value, text }, i) => (
                <option key={i} value={value}>{text}</option>
              ))}
            </Form.Control>
          </Form.Group>
        </div>
      </div>

      <div className="row cart-total-price mb-2">
        <div className="col-12 mb-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-4 label-total-price-container">
                <span>Total</span>
              </div>
              <div className="col-8 display-total-price-container">
                <span id="display_total_price" className="total-price">
                  {selectedVariant.display_price}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 text-center">
          <button
            type="button"
            className="btn btn-primary text-uppercase w-100 font-weight-normal py-2 px-4"
            id="add-to-cart-button"
            onClick={onAddToCart}
            disabled={isAddingToCart || !product.can_supply}
          >
            {isAddingToCart ? 'Adding to Cart...' : 'Add to Cart'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
